module.exports = __webpack_public_path__ + "img/people.d0c9879e.jpeg";